// API Configuration Constants
export const API_CONFIG = {
  // Prefer runtime config from environment so deployed sites can point to a secure
  // API URL (set REACT_APP_API_BASE_URL in Vercel). Fall back to the current IP
  // for local development.
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://13.60.236.18',
  // Set to 0 for no timeout (Axios default is 0). Previously 10000 (10s).
  TIMEOUT: 0,
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  ADMIN_LOGIN: '/admin/login',
  ADMIN_LOGOUT: '/admin/logout',
  REFRESH_TOKEN: '/auth/refresh',
  
  // System Prompt endpoints
  SYSTEM_PROMPT: '/system-prompt/',
  
  // Prediction endpoints
  PREDICTION: '/prediction/',
  
  // Report endpoints
  REPORT: '/report/',
  
  // User endpoints
  USER: '/user/',
  // Compatibility endpoints
  COMPATIBILITY: '/compatibility/',
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
};

// Local Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'astroguru_access_token',
  REFRESH_TOKEN: 'astroguru_refresh_token',
  USER_DATA: 'astroguru_user_data',
  REMEMBER_ME: 'astroguru_remember_me'
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your internet connection.',
  INVALID_CREDENTIALS: 'Invalid email or password.',
  SESSION_EXPIRED: 'Your session has expired. Please login again.',
  SERVER_ERROR: 'Server error. Please try again later.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  UNAUTHORIZED: 'You are not authorized to perform this action.'
};

// Chat Categories
export const CHAT_CATEGORIES = {
  GENERAL: 'general',
  LOVE: 'love',
  FAMILY: 'family',
  CAREER: 'career',
  WEALTH: 'wealth',
  HEALTH: 'health',
  PERSONALITY: 'personality',
  EDUCATION: 'education',
  TRAVEL_AND_RELOCATION: 'travel_and_relocation',
  MENTAL_WELLBEING: 'mental_wellbeing'
};

// Chat Category Options for Select Dropdown
export const CHAT_CATEGORY_OPTIONS = [
  { value: CHAT_CATEGORIES.GENERAL, label: 'General' },
  { value: CHAT_CATEGORIES.LOVE, label: 'Love' },
  { value: CHAT_CATEGORIES.FAMILY, label: 'Family' },
  { value: CHAT_CATEGORIES.CAREER, label: 'Career' },
  { value: CHAT_CATEGORIES.WEALTH, label: 'Wealth' },
  { value: CHAT_CATEGORIES.HEALTH, label: 'Health' },
  { value: CHAT_CATEGORIES.PERSONALITY, label: 'Personality' },
  { value: CHAT_CATEGORIES.EDUCATION, label: 'Education' },
  { value: CHAT_CATEGORIES.TRAVEL_AND_RELOCATION, label: 'Travel & Relocation' },
  { value: CHAT_CATEGORIES.MENTAL_WELLBEING, label: 'Mental Wellbeing' }
];